import InteractiveDiv, {
  InteractiveDivProps,
} from "@ancon/wildcat-ui/web/orderweb/InteractiveDiv/InteractiveDiv";
import "@ancon/wildcat-ui/web/orderweb/InteractiveDiv/InteractiveDiv.css";

export type { InteractiveDivProps };

export default InteractiveDiv;
